import type { BillingException } from "@shyne/shared/api";
import { appointment_status } from "@/models/appointment.model";

export const billingExceptionText = ({ missing }: BillingException): string => `Billing exception: ${missing.join(", ")}`;

type EvidenceState = { status: appointment_status; billing_exception?: BillingException | null };

export const vendorEvidenceLocked = ({ status, billing_exception }: EvidenceState): boolean =>
  status === appointment_status.completed || (status === appointment_status.done && !billing_exception);
